import CustomTag from 'components/CustomTag'
import React from 'react'

const EvaluationStatus = ({ status, offerStatus }) => {
  let colorType
  let tagMessage
  let backgroundColor

  if (status == 'SCHEDULED') {
    colorType = 'grey'
    tagMessage = 'Scheduled'
  } else if (status == 'SHORTLISTED') {
    colorType = 'green'
    tagMessage = 'Shortlisted'
  } else if (status == 'HELD_TO_COMPARE') {
    colorType = '#F3A66E'
    tagMessage = 'Hold to Compare'
    backgroundColor = '#FEF8F3'
  } else if (status == 'REJECTED') {
    colorType = 'red'
    tagMessage = 'Rejected'
    backgroundColor = '#FDF2F1'
  } else if (status == 'RESCHEDULE_REQUESTED') {
    colorType = '#F3A66E'
    tagMessage = 'Req.Reschedule'
  } else if (status == 'SELECTED') {
    colorType = 'green'
    tagMessage = 'Selected'
  } else if (status == 'RESCHEDULE') {
    colorType = 'grey'
    tagMessage = 'Reschedule'
  } else if (status == 'ABSENT') {
    colorType = 'grey'
    tagMessage = 'Absent'
  } else if (status == 'TO_BE_UPDATED' || status == 'STATUS_CONFLICT') {
    colorType = 'grey'
    tagMessage = 'Status to be updated'
  }
  return (
    <CustomTag
      colorType={colorType}
      message={tagMessage}
      bordered={false}
      background={backgroundColor}
    />
  )
}

export default EvaluationStatus
